<!-- Header Top Start -->
<section id="header-top">
    <div class="container">
        <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-12 p-0">

                <p class="p_15 p-white p-t-10">&nbsp;&nbsp;We have 25+ years of experience.</p>
            </div>
            <div class="col-md-8 col-sm-8 col-xs-12 text-right p-0">
                <div class="header-top-links">
                    <div class="social-icons text-right">
                        <ul>
                            <li><a href="https://www.facebook.com/jilabasoftware" target="_blank"><i aria-hidden="true"
                                        class="fa fa-facebook"></i></a></li>
                            <li><a href="https://twitter.com/jilabasoftware" target="_blank"><i aria-hidden="true"
                                        class="fa fa-twitter"></i></a></li>

                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>

<section id="header-bottom" class="bg_blue">
    <div class="container">
        <div class="bg-white row">
            <div class="col-md-3 col-sm-3 col-xs-12" style="margin-top:-8px;">
                <a href="http://jilaba.com/index.html"><img src="assets/images/logo.png" alt="JILABA"
                        title="Jilaba Software Services" /></a>
            </div>
            <div class="col-md-9 col-sm-9 col-xs-12">
                <div class="officeaddress">
                    <div class="addressbox" data-office="newyork">
                        <div class="get-tuch text-left"><i class="icon-telephone114 color_red"></i>
                            <ul>
                                <li>
                                    <h4>+91 44 66 600 700</h4>
                                </li>
                                <li>
                                    <p class="p_14">chennai@jilaba.com</p>
                                </li>
                            </ul>
                        </div>
                        <div class="get-tuch text-left"><i class="icon-icons74 color_red"></i>
                            <ul>
                                <li>
                                    <h4>1/120A, Valleeswaran Koil Street</h4>
                                </li>
                                <li>
                                    <p class="p_14">Manapakkam, Chennai - 125.</p>
                                </li>
                            </ul>
                        </div>
                        <div class="get-tuch text-left">
                            <a href="http://jilaba.com/iso-jilaba-software.pdf" target="_blank"> <img
                                    src="assets/images/iso.png" style="margin-top:-30px;"> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Navbar Start -->
<nav class="navbar navbar-default navbar-sticky no-background bootsnav">
    <div class="container">
        <div class="row bg-white-2">
            <div class="col-md-12">
                <!-- Start Header Navigation -->
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu"><i
                            class="fa fa-bars"></i></button>
                </div>
                <!-- End Header Navigation -->
                <!-- Collect the nav links, forms, and other content for toggling -->
                <div class="collapse navbar-collapse  nav_bor_top" id="navbar-menu">
                    <!-- <ul class="nav navbar-nav navbar-left" data-in="fadeInDown" data-out="fadeOutUp">
                        <li class="dropdown cool-link"><a href="{{this.homeurl}}">Home</a></li>
                        <li class="cool-link"><a href="{{this.aboutusurl}}">About Us</a></li>
                        <li class="cool-link"><a href="{{this.productsurl}}">Products</a></li>
                        <li class="cool-link"><a href="{{this.careersurl}}">Careers</a></li>
                        <li class="cool-link"><a href="{{this.sturegurl}}" target="_blank">Recruitment</a></li>

                        <li class="cool-link"><a href="https://jilaba.com/ticketmaintenance" target="_blank">Ticket</a></li>
                        <li class="cool-link active"><a href="{{this.contactusurl}}">Contact Us</a></li>
                        <li class="dropdown cool-link"><a href="#" class="dropdown-toggle"
                                data-toggle="dropdown">Demo</a>
                            <ul class="dropdown-menu" style="width:200px;">
                                <li><a href="{{this.vendorportalurl}}" target="_blank">VENDOR PORTAL</a></li>
                                <li><a href="{{this.aptitudeurl}}">APTITUDE TEST</a></li>
                            </ul>
                        </li>
                        <li class="cool-link"><a href="{{this.paymentlurl}}">Payment</a></li>
                    </ul> -->

                    <ul class="nav navbar-nav navbar-left" data-in="fadeInDown" data-out="fadeOutUp">
                        <li class="dropdown cool-link active"><a href="index.html">Home</a></li>
                        <li class="cool-link"><a href="aboutus.html">About Us</a></li>
                        <li class="cool-link"><a href="products.html">Products</a></li>
                        <li class="cool-link"><a href="https://jilaba.com/careers/">Careers</a></li>
                        <li class="dropdown cool-link"><a href="#" class="dropdown-toggle"
                                data-toggle="dropdown">Recruitment</a>
                            <ul class="dropdown-menu" style="width:320px;">
                                <li><a href="https://jilaba.com/StudentRegistration/" target="_blank">CAMPUS RECRUITMENT
                                        REGISTRATION</a></li>
                                <li><a href="https://jilaba.com/RecruitmentUI" target="_blank">COLLEGE LOGIN</a></li>
                            </ul>
                        </li>
                        <li class=" cool-link"><a href="https://jilaba.com/ticketmaintenance/"
                                target="_blank">Ticket</a></li>

                        <li class="cool-link"><a href="events.html">Events</a></li>
                        <li class="cool-link "><a
                                href="https://formbuilder.ccavenue.com/live/ccavenue/jilaba-software-services-pvt-ltd"
                                target="_blank">Payment</a></li>
                        <li class="cool-link"><a href="https://jilaba.com/contactus">Contact Us</a></li>
                    </ul>

                </div>
                <!-- /.navbar-collapse -->
            </div>
        </div>
    </div>
</nav>
<!-- Navbar End -->



<section id="page_banner">
    <div class="container">
        <div class="page-header text-center">
            <h2>CONTACT US</h2>
        </div>
    </div>
</section>


<section id="contact_form" class="p-t-20 p-b-50">
    <div class="container">
        <div class="row">
            <div class="col-md-7 col-sm-12 p-b-10">
                <div class="heading">
                    <div class="heading_border bg_red"></div>
                    <h3 style="margin: 0px;color: #333333;">
                        CONTACT US
                    </h3>
                    <h2 style="margin: 0px;font-size: 32px;">
                        <span> WE WANT TO </span>&nbsp; <span style="color:#1888f1"> HEAR FROM YOU</span>
                    </h2>
                </div>
                <div class="row p-t-40">
                    <div>
                        <div class="col-md-12">
                            <div id="result"></div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="single-query">
                                <input type="text" [(ngModel)]="this.names" placeholder="Your Name"
                                    class="keyword-input" required name="name" id="name">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="single-query">
                                <input type="text" [(ngModel)]="this.emailid" placeholder="Email Address"
                                    class="keyword-input" required name="email" id="email">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="single-query">
                                <input type="text" [(ngModel)]="this.mobileno" appnumber placeholder="Mobile Number"
                                    class="keyword-input" name="mobile" id="mobile">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="single-query">
                                <input type="text" [(ngModel)]="this.jewllery" placeholder="Jeweller Name"
                                    class="keyword-input" name="jewellerys" id="jewllerys">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="single-query">
                                <input type="text" [(ngModel)]="this.area" placeholder="Area" class="keyword-input"
                                    name="areas" id="areas">
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="single-query">
                                <input type="text" [(ngModel)]="this.subject" placeholder="Subject"
                                    class="keyword-input" name="subject">
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="single-query">
                                <textarea type="text" placeholder="Message" [(ngModel)]="this.message" name="message"
                                    id="message" required="required" style="height: 460px;"></textarea>
                            </div>
                        </div>


                        <div class="col-md-12">
                            <input type="submit" (click)="this.submitdata()" name="submit"
                                class="btn-light button-black">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 col-xs-12"> <br><br><br><br>
                <div class="form_left">
                    <h3 class="text-uppercase" style="margin-top: -5px">Head Office</h3>
                    <!-- <h3>Jilaba Software Services Pvt Ltd</h3> -->
                    <div class="agetn-contact-2 p-t-5"
                        style="border: 1px solid #d1d1d1;padding: 20px 20px 2px;margin-top: 1%;">
                        <p style="color:#333333;"><i class="icon-telephone114"></i>+91 44 66 600 700</p>
                        <p style="color:#333333;"><i class=" icon-icons142"></i>chennai@jilaba.com</p>
                        <p style="color:#333333;"><i class=" icon-alarmclock"></i>Mon to Sat - 10:00 to 19:00</p>
                    </div>
                    <div class="agetn-contact-2 p-t-5">
                        <p style="color:#333333;margin-top: 4%;"><i class="icon-icons74"></i>No.1/120A, Valleeswaran
                            <br> Koil Street, Manapakkam, Chennai - 600 125.
                        </p>
                    </div>
                </div>
                <div class="form_left"><br>
                    <h3 class="text-uppercase">Branch Office</h3>
                    <!-- <h3>Jilaba Software Services Pvt Ltd</h3> -->
                    <div class="agetn-contact-2 p-t-5" style="border: 1px solid #d1d1d1;padding: 20px 20px 2px;">
                        <p style="color:#333333;"><i class="icon-telephone114"></i>+91 22 2876 7962</p>
                        <p style="color:#333333;"><i class=" icon-icons142"></i>mumbai@jilaba.com</p>
                        <p style="color:#333333;"><i class=" icon-alarmclock"></i>Mon to Sat - 10:00 to 19:00</p>
                        <!--
                      <p style="color:#333333;"><i class="icon-icons74"></i>No.414, 4th Floor, "F" Building,</p>
                    <p style="color:#333333;">Master Mind IV CHS Ltd, Royal Palms,<br>
                      Aarey Milk Colony, Goregaon East,<br>
                      Mumbai - 400 065.</p>
                    -->
                    </div>
                    <div class="agetn-contact-2 p-t-5">
                        <p style="color:#333333;margin-top: 5%;"><i class="icon-icons74"></i>No.414, 4th Floor, "F"
                            Building, Master Mind IV CHS Ltd, Royal Palms,
                            Aarey Milk Colony, Goregaon East,
                            Mumbai - 400 065.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="contact-us">
    <div class="contact">
        <div class="container">
            <div class="row">
                <div class="col-md-4 hidden-xs"></div>
                <div class="col-md-4 hidden-xs"></div>
                <div class="col-md-4 col-sm-4 col-xs-12"></div>
            </div>
        </div>
        <div id="cd-google-map">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15549.359086599166!2d80.15195473782134!3d13.014021909811879!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf85ae10ddacdb302!2sJilaba+Software+Services+Private+Limited!5e0!3m2!1sen!2sin!4v1533797725739"
                width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
        </div>
    </div>
</section>

<footer id="footer_1" class="bg_blue p-t-0">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center m-t-30 m-b-20">
                <ul class="footer_link">
                    <li><a href="http://jilaba.com/index.html">Home</a></li>
                    <li><a href="http://jilaba.com/aboutus.html">About Us</a></li>
                    <li><a href="http://jilaba.com/products.html">Products</a></li>
                    <li><a href="http://jilaba.com/license_agreement.html">License Agreement</a></li>
                    <li><a href="http://jilaba.com/contactus.html">Contact us</a></li>
                </ul>
            </div>
            <div class="col-md-12 text-center">
                <p>Copyrights © 2020 Jilaba. All rights reserved.</p>
            </div>
        </div>
    </div>

</footer>